import SearchInputField from '../../../../components/Forms/Input/SearchInputField';
import SelectField from '../../../../components/Forms/Input/SelectField';

interface PreparationStationFiltersProps {
  search: string;
  active: 'ALL' | 'ACTIVE' | 'INACTIVE';
  enabled: 'ALL' | 'ENABLED' | 'DISABLED';
  printerId: number;
  printers: Array<{ id: number; name: string }>;
  onSearchChange: (value: string) => void;
  onActiveChange: (value: 'ALL' | 'ACTIVE' | 'INACTIVE') => void;
  onEnabledChange: (value: 'ALL' | 'ENABLED' | 'DISABLED') => void;
  onPrinterChange: (value: number) => void;
}

const PreparationStationFilters = ({
  search,
  active,
  enabled,
  printerId,
  printers,
  onSearchChange,
  onActiveChange,
  onEnabledChange,
  onPrinterChange,
}: PreparationStationFiltersProps) => (
  <div className="grid gap-4 border-b border-stroke p-5 dark:border-strokedark md:grid-cols-2 xl:grid-cols-4 xl:items-end">
    <div className="xl:pb-5">
      <SearchInputField
        label="Buscar"
        name="stationSearch"
        value={search}
        iconKey="search"
        placeholder="Código o nombre..."
        withMargin={false}
        onChange={(event) => onSearchChange(event.target.value)}
      />
    </div>
    <SelectField
      label="Estado"
      name="stationActive"
      value={active}
      options={[
        { value: 'ALL', label: 'Todas' },
        { value: 'ACTIVE', label: 'Activas' },
        { value: 'INACTIVE', label: 'Inactivas' },
      ]}
      onChange={(event) => onActiveChange(event.target.value as 'ALL' | 'ACTIVE' | 'INACTIVE')}
    />
    <SelectField
      label="Disponibilidad"
      name="stationEnabled"
      value={enabled}
      options={[
        { value: 'ALL', label: 'Todas' },
        { value: 'ENABLED', label: 'Habilitadas' },
        { value: 'DISABLED', label: 'Deshabilitadas' },
      ]}
      onChange={(event) => onEnabledChange(event.target.value as 'ALL' | 'ENABLED' | 'DISABLED')}
    />
    <SelectField
      label="Impresora"
      name="stationPrinter"
      value={printerId}
      options={[
        { value: 0, label: 'Todas las impresoras' },
        ...printers.map((printer) => ({ value: printer.id, label: printer.name })),
      ]}
      onChange={(event) => onPrinterChange(Number(event.target.value))}
    />
  </div>
);

export default PreparationStationFilters;
